<template>
  <section>
    <el-collapse v-model="isOpen">
      <el-collapse-item
        :title="$t('common.search')"
        name="holiday-periods-search-section"
        id="holiday-periods-search-section"
      >
        <el-form
          id="holiday-periods-search-section-form"
          class="search-section-form"
          :model="searchForm"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('admin.holidayPeriods.name')">
                <el-input
                  v-model="searchForm.name"
                  clearable
                  @clear="handleSearch"
                  class="inline-input"
                  ref="filter-name"
                  id="searchForm-name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('admin.holidayPeriods.effectiveDate')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  v-model="searchForm.effectiveDate"
                  format="MM/dd/yyyy"
                  clearable
                  type="date"
                  id="searchForm-effectiveDate"
                  ref="filter-effectiveDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="text-align-end">
              <el-tooltip
                  :content="$t('common.search')"
                  class="item"
                  effect="dark"
                  placement="top-start"
              >
                <el-button
                    id="holiday-periods-search-section-form-button"
                    class="button-action-default"
                    @click="handleSearch"
                    icon="el-icon-search"
                    size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SearchFilter',
  data() {
    return {
      searchForm: {
        name: null,
        effectiveDate: null
      }
    };
  },
  computed: {
    ...mapState({
      isOpen: state => state.holidayPeriods.filtersOpen,
      actualFilters: state => state.holidayPeriods.actualFilters
    })
  },
  mounted() {
    this.initializeForm();
    this.handleSearch();
  },
  methods: {
    initializeForm() {
      this.searchForm = {
        name: this.actualFilters.name,
        effectiveDate: this.actualFilters.effectiveDate
      };
    },
    handleSearch() {
      const filters = {
        name: this.searchForm.name,
        effectiveDate: this.searchForm.effectiveDate
      };
      this.$store.dispatch('holidayPeriods/search', filters);
    }
  }
};
</script>
